const ODP_SEGMENT = "/data";

/**
 * Returns the URL of the ODP page the app is mounted on (e.g. "/en/data"), to be used as the router's history base.
 *
 * Without a base, router paths like "/search" are root-relative: a reload then asks the CMS for "/search", which is
 * the Wagtail site search. The CMS serves the ODP page for its "dashboard" and "search" subpaths
 * (ODPUIPage.vue_route in ccikewebsite-wagtail), so the top-level routes must stay in sync with it.
 */
export function getOdpHistoryBase(pathname) {
  const index = pathname.indexOf(ODP_SEGMENT);
  if (index === -1) {
    return "/";
  }
  return pathname.slice(0, index + ODP_SEGMENT.length);
}
